// src/utils/scheduledFacturaPayload.js

export const mapDayOfWeekToDto = uiDay => {
  // Back: 0..6
  // Convención: Sunday=0, Monday=1 ... Saturday=6
  const map = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
  }
  return map[uiDay] ?? 1
}

export const toNumber = v => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

export const todayYYYYMMDD = () => {
  const d = new Date()
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

/**
 * Construye el payload para el backend desde tu formState (UI)
 * Asume:
 * - formState.config.frequency ya viene como:
 *   'daily' | 'weekly' | 'monthly' | 'quarterly' | 'semiannual' | 'yearly'
 * - formState.config usa snake_case:
 *   start_date, day_of_month, day_of_week, emission_day_adjustment,
 *   end_type, end_date, max_occurrences
 */
export const buildScheduledFacturaPayload = (formState, senderEntityId) => {
  const client = formState?.client || {}
  const cfg = formState?.config || {}

  const frequency = cfg.frequency // ya viene listo

  const payload = {
    dte_type: String(formState.documentType),
    sender: Number(senderEntityId),
    receiver_tax_id: String(client.tax_id || client.rut || '').replace(/\./g, ''),

    frequency,

    // si no viene => hoy
    start_date: cfg.start_date?.trim() ? cfg.start_date : todayYYYYMMDD(),

    // moneda del documento (no la de la línea)
    currency: formState.currency,

    // ajuste día hábil
    emission_day_adjustment: cfg.emission_day_adjustment || 'none',

    // día cambio UF
    currency_day: formState.currency === 'UF' ? toNumber(cfg.currency_day || 1) : undefined,

    // término de programación
    end_type: cfg.end_type || 'never',

    // status fijo
    status: 'active',

    // details
    details: (formState.details || []).map(d => ({
      item_name: String(d.item_name || '').trim(),
      item_description:
        d.showDescription && d.item_description?.trim()
          ? String(d.item_description).trim()
          : undefined,
      quantity: toNumber(d.quantity),
      unit_price: toNumber(d.unit_price),

      // ✅ nuevos campos
      item_code: d.item_code?.trim() ? String(d.item_code).trim() : undefined,
      item_type_code: d.item_type_code?.trim() ? String(d.item_type_code).trim() : undefined
    })),
    references: (formState.references || [])
      .filter(r => r.dte_type_code || r.reference_folio)
      .map(r => ({
        reference_folio: String(r.reference_folio || '').trim(),
        reference_date: r.reference_date || undefined,
        reference_reason: String(r.reference_reason || '').trim(),
        dte_type_code: String(r.dte_type_code || '')
      }))
  }

  // Opcionales según frecuencia
  if (frequency === 'weekly') {
    payload.day_of_week = mapDayOfWeekToDto(cfg.day_of_week || 'monday')
  }

  if (['monthly', 'quarterly', 'semiannual', 'yearly'].includes(frequency)) {
    payload.day_of_month = toNumber(cfg.day_of_month || 1)
  }

  // End handling
  if (payload.end_type === 'on_date') {
    payload.end_date = cfg.end_date || '' // valida antes de enviar
    payload.max_occurrences = null
  } else if (payload.end_type === 'after_occurrences') {
    payload.max_occurrences = toNumber(cfg.max_occurrences) // Ensure numeric
    payload.end_date = undefined
  } else {
    // never
    payload.end_date = undefined
    payload.max_occurrences = null
  }

  return payload
}
